<div class="max-w-screen-2xl px-32 py-14 mx-auto">
  <div class="flex justify-between items-center mb-12">
    <span class="mat-display-2 font-bold mb-0">Adminkezelés</span>
    <button
      mat-flat-button
      color="primary"
      (click)="openCreateAdminDialog()"
      class="mol-btn-md"
    >
      <mat-icon aria-label="Add icon">add</mat-icon>
      Admin hozzáadása
    </button>
  </div>

  <mat-card class="mat-elevation-z0 rounded-2xl p-14">
    <table
      mat-table
      [dataSource]="dataSource"
      fixedLayout="true"
      class="mat-elevation-z0 w-full"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Név</th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'mat-disabled-color': element.status === 'DEACTIVATED' }"
        >
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email cím</th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'mat-disabled-color': element.status === 'DEACTIVATED' }"
        >
          {{ element.email }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="w-36">Hozzáadva</th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'mat-disabled-color': element.status === 'DEACTIVATED' }"
          class="w-36"
        >
          {{ formatDate(element.createdAt) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef class="w-48"></th>
        <td mat-cell *matCellDef="let element" class="w-48">
          <button
            mat-button
            color="primary"
            (click)="openEditAdminDialogFor(element)"
            class="rounded-xl py-1 px-4 text-base font-bold"
          >
            <mat-icon
              color="primary"
              aria-label="Delete icon"
              class="material-icons-outlined"
              >edit</mat-icon
            >
            Szerkesztés
          </button>
          <button
            mat-icon-button
            [matMenuTriggerFor]="moreOptions"
            aria-label="Options icon"
            class="w-8 h-8 leading-8"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #moreOptions="matMenu" xPosition="before">
            <button
              mat-menu-item
              *ngIf="element.status === 'DEACTIVATED'; else activateAdmin"
              (click)="openActivateAdminDialogFor(element)"
            >
              <mat-icon color="primary" class="mr-2">replay</mat-icon>
              <span>Aktiválás</span>
            </button>
            <ng-template #activateAdmin>
              <button
                mat-menu-item
                (click)="openDeactivateAdminDialogFor(element)"
              >
                <mat-icon color="warn" class="material-icons-outlined mr-2"
                  >do_not_disturb_on</mat-icon
                >
                <span>Deaktiválás</span>
              </button>
            </ng-template>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [hidden]="this.loading"
      ></tr>
    </table>

    <div
      *ngIf="!dataAvailable()"
      class="flex flex-col justify-center items-center h-96"
    >
      <mat-spinner *ngIf="this.loading; else tableEmpty"></mat-spinner>

      <ng-template #tableEmpty>
        <img
          alt="No results"
          src="../../../assets/figures/man-questioning.svg"
          class="h-[88px] mb-2"
        />
        <p class="text-lg font-bold">Nincs találat</p>
        <p class="text-sm">A tábla amit felkerestél üres.</p>
      </ng-template>
    </div>
  </mat-card>

  <mat-paginator
    [length]="this.dataLength"
    [pageSize]="this.pageSize"
    [pageSizeOptions]="this.pageSizeOptions"
    (page)="onPagination($event)"
    aria-label="Select page"
    class="rounded-2xl mt-6"
  >
  </mat-paginator>
</div>
